import axios from 'axios';

interface UserAvailabilityInterface {
  pointOfSaleId: string;
  serviceId: string;
  startTime: string;
  endTime: string;
}

export const userAvailability = async ({
  pointOfSaleId,
  serviceId,
  startTime,
  endTime,
}: UserAvailabilityInterface): Promise<string> => {
  try {
    const {
      data: { data },
    } = await axios.post(`/api/User/Availability`, {
      pointOfSaleId,
      serviceId,
      startTime,
      endTime,
    });

    return data;
  } catch (error) {
    console.error(error);
    return '';
  }
};
